import vue from 'vue';
import { default as Component } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { AppSidebar } from '../../template/app-sidebar';
import { DashboradNavigationBlock } from '../../template/dashborad-navigation-block';

import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';

import Lesson from '../../../interfaces/Lesson';

import * as _ from "../../../../node_modules/lodash";

@Component({
  template: require('./lesson-page.html'),
  components: {
    'app-sidebar': AppSidebar,
    'dashborad-navigation-block': DashboradNavigationBlock,
  },
  props: {
    id: [Number, String],
  },
})
export class LessonPage extends vue {
  id;

  lessonData = {
    id: Number,
    body: String,
    status: String,
    title: String,
  };

  lessonProvider = IocContainer.get < Lesson > (SERVICES.LESSON);
  notPassLastUnit = false;

  mounted() {
    this.loadData();
  }

  @Watch('id')
  onPageReload(val: string) {
    this.loadData();
  }

  // Preloader
  get loading() {
    return this.loadingUser && this.loadingLesson;
  }

  get loadingUser() {
    return this.$store.state.loadingUser;
  }

  get loadingLesson() {
    return this.lessonData.body.length > 1 && this.lessonsData.length > -1;
  }

  // Expiration
  get expired() {
    if (new Date(this.$store.state.user.expiration.replace(/ /g,"T")) > new Date()){
      return false;
    }
    else{
      if (this.userProgress.length > 0 && this.lessonsData.length > 0){
        if (this.userProgress[this.userProgress.length - 1].type == this.lessonsData[Object.keys(this.lessonsData)[Object.keys(this.lessonsData).length - 1]].type){
          return this.userProgress[this.userProgress.length - 1].id != this.lessonsData[Object.keys(this.lessonsData)[Object.keys(this.lessonsData).length - 1]].id;
        }
      }
      return true;
    }
  }
  
  // Data
  get lessonsData() {
    return this.$store.state.lessons;
  }

  get userProgress() {
    return this.$store.state.progress;
  }

  // DataIndexes
  get lessonIndex() {
      return this.lessonsData.indexOf(this.lessonsData.find((lesson) => {
        return lesson.id === this.lessonData.id && lesson.type === 'App\\Models\\Lesson' && !lesson.hasOwnProperty('reset');
      }));
  }
  get blockNumber() {
      return this.lessonsData.find((lesson) => {
        return lesson.id === this.lessonData.id || lesson.id === this.id && lesson.type === 'App\\Models\\Lesson';
      }).orderBlock;
  }

  get unitNumber() {
      return this.lessonsData.find((lesson) => {
        return lesson.id === this.lessonData.id || lesson.id === this.id && lesson.type === 'App\\Models\\Lesson';
      }).orderUnit;
  }

  get lessonNumber() {
      return this.lessonsData.find((lesson) => {
        return lesson.id === this.lessonData.id && lesson.type === 'App\\Models\\Lesson' || lesson.id === this.id && lesson.type === 'App\\Models\\Lesson';
      }).orderLesson;
  }

  // Titles
  get courseTitle() {
    return this.$store.state.courseTitle;
  }

  get blockTitle() {
    if (this.lessonsData[this.lessonIndex]) {
      return this.$store.state.course.find((course) => {
        return course.units.find((unit) => {
          return (unit.id == this.lessonsData[this.lessonIndex].unitId);
        })
      }).title;
    }
  }

  get unitTitle() {
    if (this.lessonsData[this.lessonIndex]) {
      let units = this.$store.state.course.find((course) => {
        return course.units.find((unit) => {
          return (unit.id == this.lessonsData[this.lessonIndex].unitId);
        })
      });
      return units.units.find((unit) => {
        return (unit.id == this.lessonsData[this.lessonIndex].unitId);
      }).title;
    }
  }

  // Buttons
  get previousButtonIndex() {
    if (this.lessonIndex > 0 && this.lessonIndex <= this.lessonsData.length - 1) {
      return this.lessonIndex - 1;
    }
    return false;
  }

  get previousButtonDisplay() {
    return (this.lessonIndex > 0 && this.lessonIndex <= this.lessonsData.length - 1) ? true : false;
  }

  get nextButtonIndex() {
    if (this.lessonIndex >= 0 && this.lessonIndex < this.lessonsData.length - 1) {
      return this.lessonIndex + 1;
    }
    return false;
  }

  get nextButtonDisplay() {
    return (this.lessonIndex >= 0 && this.lessonIndex < this.lessonsData.length - 1) ? true : false;
  }

  // Logic
  
  // get wasThere() {
  //   if (this.lessonsData[this.lessonIndex]) {
  //     return this.lessonsData[this.lessonIndex].pass;
  //   }
  // }

  // Refactor this
  get wasThere() {
    if (this.lessonsData[this.lessonIndex]) {
      let lessonid = this.lessonsData[this.lessonIndex].id;
        if (this.userProgress.find((lesson) => {
          return lesson.id == lessonid && lesson.type === 'App\\Models\\Lesson';
        }) == undefined){
          return false;
        }
        else if(this.userProgress.find((lesson) => {
          return lesson.id == lessonid && lesson.type === 'App\\Models\\Lesson'
        }).reset == true){
          return false;
        }
      else{
        return this.userProgress.find((lesson) => {
          return lesson.id == lessonid && lesson.type === 'App\\Models\\Lesson';
        }).pass;
      }
    }
  }

  get firstUnitLesson() {
    if (this.lessonsData[this.lessonIndex]) {
      return (this.lessonsData[this.lessonIndex].order.substr(this.lessonsData[this.lessonIndex].order.length - 2) == '00');
    }
  }

  get passPrevious() {
    if (this.lessonIndex === 0) {
      return true;
    }
    if (this.lessonIndex >= 1) {
      //investigate here
      const pastLesson = (typeof this.lessonsData[this.lessonIndex - 1] !== undefined) ? this.lessonsData[this.lessonIndex - 1] : false;
      if (pastLesson) {

        const lastChar = this.lessonsData[this.lessonIndex].order.substr(this.lessonsData[this.lessonIndex].order.length - 2);

        if (lastChar == '00') {

          // const units = this.userProgress.filter((lesson) => {
          //   return lesson.orderBlock === pastLesson.orderBlock && lesson.type === 'App\\Models\\Quiz' && !lesson.hasOwnProperty('reset');
          //   // return lesson.unitId === pastLesson.unitId && lesson.type === 'App\\Models\\Quiz' && !lesson.hasOwnProperty('reset');
          // })

          //units is no needed further, left it just in case
          const units = this.lessonsData.filter((lesson) => {
            // return lesson.orderBlock === pastLesson.orderBlock && lesson.type === 'App\\Models\\Quiz' && !lesson.hasOwnProperty('reset');
            return lesson.unitId === pastLesson.unitId && lesson.type === 'App\\Models\\Quiz' && !lesson.hasOwnProperty('reset');
          })


          // const uniq = _.uniqBy(this.lessonsData, function(lesson){
          //   // console.log(lesson.unitId);
          //   return lesson.unitId;
          // });

          // const uniqPassed = [...new Set(this.userProgress.map(lesson => lesson.unitId))];
          // console.log(uniqPassed);
          // console.log(distUnits);

          const uniqPassed = [];
          const map = new Map();
          for (const item of this.userProgress) {
              if(!map.has(item.unitId) && !item.hasOwnProperty('reset')){
                  map.set(item.unitId, true);
                  uniqPassed.push({
                      id: item.unitId,
                      orderBlock: this.lessonsData.find((lesson) => {
                        return lesson.id === item.id && lesson.type === item.type;
                      }).orderBlock
                  });
                  // console.log(uniqPassed);
              }
          }
          // console.log(uniqPassed);
          // const uniqPassed = uniq.splice(0, uniq.indexOf(uniq.find((lesson) => {
          //   return lesson.unitId == units[0].unitId})) + 1
          // );
          // console.log(uniqPassed);
          // const unitsPassed = this.lessonsData.filter((lesson)=> {
          //   return lesson.orderBlock === uniqPassed[0].orderBlock && lesson.type === 'App\\Models\\Quiz'; //
          // })
//need to refactor
          let unitsResults = [];
            for (var i = 0; i < uniqPassed.length; i++) {
              var hasResult = (this.userProgress.filter((lesson) => {
                return lesson.orderBlock === uniqPassed[i].orderBlock && lesson.type === 'App\\Models\\Quiz' && lesson.hasOwnProperty('result') && !lesson.hasOwnProperty('reset');
              }));
              // console.log(uniqPassed[i].orderBlock);
              var newUnitsPass = this.lessonsData.filter((lesson) => {
                // console.log(uniqPassed[i]);
                return lesson.orderBlock === uniqPassed[i].orderBlock && lesson.type === 'App\\Models\\Quiz';
              });
              let total = 0;
              for (let i = 0; i < newUnitsPass.length; i++) {
                let lessonInUnit= this.userProgress.find((lesson) => {
                  return lesson.id == newUnitsPass[i].id && lesson.type === newUnitsPass[i].type && !lesson.hasOwnProperty('reset');
                })
                if (lessonInUnit){
                  if (lessonInUnit.resultPercentage){
                  total += lessonInUnit.resultPercentage;
                  }
                }
              }
              if (total != 0){
                let avg = Math.round(total / hasResult.length);
                // console.log(newUnitsPass, '-', avg)
                if (avg != 0){
                  unitsResults.push(avg);
                  // console.log(unitsResults);
                }
              }
            }


          // for (let i = 0; i < units.length; i++) {
          //   total += this.userProgress.find((lesson) => {
          //     return lesson.id == units[i].id && lesson.type === units[i].type;
          //   }).resultPercentage;
          // }

          // let avg = total / units.length;

          const passUnit = unitsResults.every(function isPositive(number) {return (Math.round(number) >= 65)}) ? true : false;
          if (passUnit) {
            this.notPassLastUnit = false;
            return passUnit;
          } else {
            this.notPassLastUnit = true;
            return passUnit;
          }

        }
        return this.userProgress.indexOf(this.userProgress.find((lesson) => {
          if (pastLesson.type === 'App\\Models\\Quiz'){
            return lesson.id === pastLesson.id && lesson.type === pastLesson.type && !lesson.hasOwnProperty('reset') && lesson.hasOwnProperty('result') ;
          }
          return lesson.id === pastLesson.id && lesson.type === pastLesson.type && !lesson.hasOwnProperty('reset');
        })) > -1;
      }

      return false;
    }
  }


  // Functions
  loadData() {
    this.lessonProvider.getLesson(this.id).then(
      (response) => {
        this.lessonData = response.data;
      },
      (error) => {
        if (error){
          console.error(error);
        }
        //need to double check this;
        location.reload();
      },
    );
  }

  saveAndContinue() {
    this.$store.dispatch('saveLessonProgress', this.lessonsData[this.lessonIndex]);

    if (this.isLesson(this.nextButtonIndex)) {
      this.$router.push({
        name: 'lesson',
        params: {
          id: this.lessonsData[this.nextButtonIndex].id,
        },
      });
    }

    if (this.isQuiz(this.nextButtonIndex)) {
      this.$router.push({
        name: 'quiz',
        params: {
          id: this.lessonsData[this.nextButtonIndex].id,
        },
      });
    }
  }

  isLesson(buttonIndex) {
    if (this.lessonsData[buttonIndex]) {
      return (this.lessonsData[buttonIndex].type === 'App\\Models\\Lesson') ? true : false;
    }
  }

  isQuiz(buttonIndex) {
    if (this.lessonsData[buttonIndex]) {
      return (this.lessonsData[buttonIndex].type === 'App\\Models\\Quiz') ? true : false;
    }
  }
}